class SwymWishlist extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.products = []
    this.currentProducts = []

    if (!this.els.items || !this.els.items.element) return
    this.initialize()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleRemoveClick.bind(this))
  }

  initialize () {
    this.handleProducts = this.handleProducts.bind(this)
    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push(swat => {
      this.swymCallback(swat)
    })

    // A product could now be added from the carousel
    window.SwymCallbacks.push(swat => {
      swat.evtLayer.addEventListener('sw:addedtowishlist', () => {
        window.location.reload()
      })
    })
  }

  swymCallback (swat) {
    this.swat = swat
    swat.fetchWrtEventTypeET(products => {
      this.products = products
      this.handleProducts()
    }, 4)
  }

  async handleProducts () {
    this.currentProducts = this.products.slice(this.startPoint, this.endPoint)
    this.handleStates()
    if (this.currentProducts.length) {
      const productCardHTML = await this.getAllProductCardHTML()
      this.els.items.element.innerHTML = productCardHTML
      this.updateItemIndexes()
    } else {
      this.els.items.element.innerHTML = ''
    }
    this.updatePagination()

    this.setAttribute('aria-hidden', this.products.length === 0)
  }

  async getAllProductCardHTML () {
    const productCardHTML = await Promise.all(
      this.currentProducts.map(
        async (product, index) => await this.getProductCardHTML(product, index),
      ),
    )
    return productCardHTML.filter(Boolean).join('')
  }

  async getProductCardHTML (product, index) {
    return fetch(`${product.du}?section_id=${this.sectionId}`)
      .then(r => {
        // Products that don't exist will return a 404
        if (r.status === 200 && r.redirected === false) {
          return r.text()
        }
        return null
      })
      .then(productCardHTML => {
        if (productCardHTML) {
          return `<div class="swym-Wishlist_Item" ${this.selectors.item}
            data-epi="${product.epi}"
            data-du="${product.du}"
            data-empi="${product.empi}"
            data-iu="${product.iu}"
            data-pr="${product.pr}"
            >
            ${window.BAO.sectionRenderer.getInnerHtml(productCardHTML)}
          </div>`
        }
        return null
      })
  }

  async handleRemoveClick (event) {
    const removeButton = event.target.closest(`[${this.selectors.remove}]`)
    const item = event.target.closest(`[${this.selectors.item}]`)
    if (!removeButton || !item) return
    item.setAttribute('aria-busy', 'true')
    this.swat.removeFromWishList(Object.assign({}, item.dataset), () => {
      setTimeout(async () => {
        item.remove()
        await this.replaceRemovedCard(item)
        this.updateItemIndexes()
        this.updatePagination()
        this.handleStates()
      }, 500)
    })
  }

  async replaceRemovedCard (item) {
    this.products.splice(parseInt(item.dataset.index, 10), 1)
    this.currentProducts = this.products.slice(this.startPoint, this.endPoint)
    const product = this.products.at(
      this.productsPerPage * this.currentPage - 1,
    )
    if (!product) return
    this.els.items.element.insertAdjacentHTML(
      'beforeend',
      await this.getProductCardHTML(product),
    )
  }

  updateItemIndexes () {
    this.els.items.element
      .querySelectorAll(`[${this.selectors.item}]`)
      .forEach((item, index) => {
        item.setAttribute(
          'data-index',
          (this.currentPage - 1) * this.productsPerPage + index,
        )
      })
  }

  handleStates () {
    this.externalEls.header.element.setAttribute('aria-hidden', 'false')
    this.handleEmptyState()
  }

  handleCarousel () {
    const carousel = document.querySelector('.sec-Section_Wishlist-carousel')

    if (carousel) {
      if (this.products.length > 0) {
        carousel.setAttribute('aria-hidden', 'true')
      } else {
        carousel.removeAttribute('aria-hidden')
      }
    }
  }

  handleEmptyState () {
    if (
      !this.externalEls['header-title'] ||
      !this.externalEls['header-description']
    ) { return }

    const emptyStateData = {
      title: this.externalEls['header-title'].element.dataset.emptyTitle,
      description: this.externalEls['header-description'].element.dataset
        .emptyText,
    }

    const populatedStateData = {
      title: this.externalEls['header-title'].element.dataset.populatedTitle,
      description: this.externalEls['header-description'].element.dataset
        .populatedText,
    }

    this.externalEls['header-title'].element.innerText =
      this.products.length > 0 ? populatedStateData.title : emptyStateData.title

    this.externalEls['header-description'].element.innerText =
      this.products.length > 0
        ? populatedStateData.description
        : emptyStateData.description

    this.setAttribute('aria-hidden', this.products.length === 0)

    this.handleCarousel()
  }

  updatePagination () {
    const hasPreviousEl = this.els.previous && this.els.previous.element
    const hasNextEl = this.els.next && this.els.next.element

    if (hasPreviousEl) {
      this.els.previous.element.setAttribute(
        'aria-hidden',
        (!this.hasPreviousPage).toString(),
      )
      this.els.previous.element.setAttribute(
        'href',
        `${this.requestPath}/?page=${this.currentPage - 1}`,
      )
    }

    if (hasNextEl) {
      this.els.next.element.setAttribute(
        'aria-hidden',
        (!this.hasNextPage).toString(),
      )
      this.els.next.element.setAttribute(
        'href',
        `${this.requestPath}/?page=${this.currentPage + 1}`,
      )
    }

    if (
      hasPreviousEl &&
      hasNextEl &&
      !this.hasPreviousPage &&
      !this.hasNextPage
    ) {
      this.els.previous.element.remove()
      this.els.next.element.remove()
    }
  }

  get params () {
    const urlSearchParams = new URLSearchParams(window.location.search)
    return Object.fromEntries(urlSearchParams.entries())
  }

  get productsPerPage () {
    return 12
  }

  get currentPage () {
    return this.params.page && parseInt(this.params.page, 10) > 0
      ? parseInt(this.params.page, 10)
      : 1
  }

  get startPoint () {
    return this.productsPerPage * this.currentPage - this.productsPerPage
  }

  get endPoint () {
    return this.productsPerPage * this.currentPage
  }

  get hasPreviousPage () {
    return this.currentPage > 1
  }

  get hasNextPage () {
    return this.products.length > this.productsPerPage * this.currentPage
  }

  get sectionId () {
    return 'swym-product-card'
  }

  set swat (swat) {
    this._swat = swat
  }

  get swat () {
    return this._swat
  }

  get selectors () {
    return {
      item: `data-${this.identifier}-el="item"`,
      remove: `data-${this.identifier}-el="remove"`,
    }
  }

  get requestPath () {
    return this.dataset.requestPath
      ? this.dataset.requestPath
      : '/pages/wishlist'
  }
}

if (!customElements.get('swym-wishlist')) {
  customElements.define('swym-wishlist', SwymWishlist)
}
